// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r1gL","left":"styles_left__2nbRL","desktopActions":"styles_desktopActions__3FlFZ","title":"styles_title__TKLHS"};